"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ListBox = ListBox;
exports["default"] = exports.defaultProps = exports.propTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("@paprika/helpers/lib/polyfills/elementScroll");

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _Box = _interopRequireDefault(require("./components/Box"));

var _Content = _interopRequireDefault(require("./components/Content"));

var _List = _interopRequireDefault(require("./components/List"));

var _NoResults = _interopRequireDefault(require("./components/NoResults"));

var _Options = _interopRequireDefault(require("./components/Options"));

var _Popover = _interopRequireDefault(require("./components/Popover"));

var _Trigger = _interopRequireDefault(require("./components/Trigger"));

var _useListBox5 = _interopRequireDefault(require("./useListBox"));

var _OnChangeProvider = require("./store/OnChangeProvider");

var _PropsProvider = require("./store/PropsProvider");

var _imperative = _interopRequireDefault(require("./imperative"));

var _hooks = require("./hooks");

var _excluded = ["children", "hasImplicitAll", "height", "isOpen", "hasError", "hasTag", "isDisabled", "isInline", "isMulti", "isReadOnly", "onChange", "placeholder", "size", "contentOffsetX", "contentOffsetY", "data", "box", "filter", "footer", "trigger", "content"],
    _excluded2 = ["children", "hasImplicitAll", "height", "isMulti", "onChange", "isOpen", "hasError", "hasTag", "isDisabled", "isInline", "isReadOnly", "placeholder", "size", "contentOffsetX", "contentOffsetY", "box", "filter", "footer", "popover", "trigger", "content"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ListBox(props) {
  var children = props.children,
      hasImplicitAll = props.hasImplicitAll,
      height = props.height,
      isOpen = props.isOpen,
      hasError = props.hasError,
      hasTag = props.hasTag,
      isDisabled = props.isDisabled,
      excludedIsInline = props.isInline,
      isMulti = props.isMulti,
      excludedIsReadOnly = props.isReadOnly,
      onChange = props.onChange,
      placeholder = props.placeholder,
      size = props.size,
      contentOffsetX = props.contentOffsetX,
      contentOffsetY = props.contentOffsetY,
      data = props.data,
      box = props.box,
      filter = props.filter,
      footer = props.footer,
      _trigger = props.trigger,
      content = props.content,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var I18n = (0, _useI18n["default"])();

  var _useListBox = (0, _useListBox5["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      _useListBox2$ = _useListBox2[0],
      noResultsFound = _useListBox2$.noResultsFound,
      refFooterContainer = _useListBox2$.refFooterContainer;

  var _React$useContext = _react["default"].useContext(_PropsProvider.PropsContext),
      isInline = _React$useContext.isInline,
      isReadOnly = _React$useContext.isReadOnly;
  /* eslint-disable react/prop-types */


  var onClickFooterAccept = footer ? footer.props.onClickAccept : null;
  var onCancelFooter = footer ? footer.props.onClickCancel : null;
  var noResultsMessage = filter ? filter.props.noResultsMessage || I18n.t("listBox.filter.no_results_message") : null;
  var boxProps = box ? box.props : null;
  var contentProps = content ? _objectSpread(_objectSpread({}, content.props), {}, {
    onCancelFooter: onCancelFooter
  }) : {
    onCancelFooter: onCancelFooter
  };
  /* eslint-enable react/prop-types */

  var propsForTrigger = {
    hasClearButton: true,
    hasImplicitAll: hasImplicitAll,
    onClickClear: null,
    onClickFooterAccept: onClickFooterAccept
  };
  var listProps = {
    height: height,
    hasOptions: !noResultsFound
  };
  var trigger = _trigger ? /*#__PURE__*/_react["default"].cloneElement(_trigger, _objectSpread({}, _trigger.props)) : /*#__PURE__*/_react["default"].createElement(_Trigger["default"], propsForTrigger);

  var listBox = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, trigger, isInline || !isReadOnly ? /*#__PURE__*/_react["default"].createElement(_Content["default"], contentProps, /*#__PURE__*/_react["default"].createElement(_Box["default"], boxProps, isReadOnly ? null : filter, /*#__PURE__*/_react["default"].createElement(_List["default"], listProps, /*#__PURE__*/_react["default"].createElement(_Options["default"], {
    isPopoverOpen: isOpen
  }, children)), filter ? /*#__PURE__*/_react["default"].createElement(_NoResults["default"], {
    label: noResultsMessage
  }) : null, footer && !isReadOnly ? /*#__PURE__*/_react["default"].cloneElement(footer, {
    ref: refFooterContainer
  }) : null)) : null);

  return isInline ? /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-pka-anchor": "list-box"
  }, moreProps), listBox) : listBox;
}

var ListBoxContainer = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      hasImplicitAll = props.hasImplicitAll,
      height = props.height,
      isMulti = props.isMulti,
      onChange = props.onChange,
      isOpen = props.isOpen,
      hasError = props.hasError,
      hasTag = props.hasTag,
      isDisabled = props.isDisabled,
      isInline = props.isInline,
      isReadOnly = props.isReadOnly,
      placeholder = props.placeholder,
      size = props.size,
      contentOffsetX = props.contentOffsetX,
      contentOffsetY = props.contentOffsetY,
      box = props.box,
      filter = props.filter,
      footer = props.footer,
      popover = props.popover,
      trigger = props.trigger,
      content = props.content,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);

  var _useListBox3 = (0, _useListBox5["default"])(),
      _useListBox4 = (0, _slicedToArray2["default"])(_useListBox3, 2),
      state = _useListBox4[0],
      dispatch = _useListBox4[1];

  var onChangeContext = _react["default"].useContext(_OnChangeProvider.OnChangeContext);

  var providedProps = _react["default"].useContext(_PropsProvider.PropsContext);
  /* eslint-disable react/prop-types */


  var shouldTriggerKeepFocus = popover && popover.props.shouldKeepFocus;
  var popoverProps = popover && popover.props;
  /* eslint-enable react/prop-types */
  // IMPERATIVE API

  var imperativeHandle = (0, _imperative["default"])({
    state: state,
    dispatch: dispatch,
    onChangeContext: onChangeContext
  });

  _react["default"].useImperativeHandle(ref, imperativeHandle); // HOOKS


  (0, _hooks.useAdjustWidth)();
  (0, _hooks.useChildrenChange)(children);
  (0, _hooks.useIsPopOverOpen)(shouldTriggerKeepFocus);
  (0, _hooks.useOptionSelected)();
  (0, _hooks.useHasFooter)(footer);

  var propsForListBox = _objectSpread({
    hasImplicitAll: hasImplicitAll,
    height: height,
    isOpen: isOpen,
    box: box,
    filter: filter,
    footer: footer,
    trigger: trigger,
    content: content
  }, providedProps.isInline ? moreProps : {});

  var listBox = /*#__PURE__*/_react["default"].createElement(ListBox, propsForListBox, children);

  if (providedProps.isInline) {
    return listBox;
  }

  if (popover) {
    var PopoverClone = /*#__PURE__*/_react["default"].cloneElement(popover, _objectSpread(_objectSpread({}, popoverProps), {}, {
      children: listBox
    }));

    return PopoverClone;
  }

  delete moreProps.selectedKeys;
  delete moreProps.setSelectedKeys;
  delete moreProps.snapshotSelectedKeys;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-pka-anchor": "list-box"
  }, moreProps), /*#__PURE__*/_react["default"].createElement(_Popover["default"], null, listBox));
});

ListBoxContainer.types = {
  size: constants.defaultSize
};
var propTypes = {
  /** Child of type <ListBox.Option />, <ListBox.Divider />, etc */
  children: _propTypes["default"].arrayOf(_propTypes["default"].node),

  /** If ListBox is in an error state  */
  hasError: _propTypes["default"].bool,

  /** If there is a tag */
  hasTag: _propTypes["default"].bool,

  /** Has implicit "All items selected" value when no item is selected */
  hasImplicitAll: _propTypes["default"].bool,

  /** The maximum height for the options container. Using a number implies px units. */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Disables the ListBox if true */
  isDisabled: _propTypes["default"].bool,

  /** This options will display the list-box without the Popover */
  isInline: _propTypes["default"].bool,

  /** Let the user to select multiple options at same time */
  isMulti: _propTypes["default"].bool,

  /** Indicates if the popover is visible */
  isOpen: _propTypes["default"].bool,

  /** The ListBox will not allow value to be changed */
  isReadOnly: _propTypes["default"].bool,

  /** Callback returning the current selection on the ListBox */
  onChange: _propTypes["default"].func,

  /** Default label for trigger when the ListBox has no option selected */
  placeholder: _propTypes["default"].string,

  /** Size of the trigger and options (font size, height, padding, etc). */
  size: _propTypes["default"].oneOf([ListBoxContainer.types.size.SMALL, ListBoxContainer.types.size.MEDIUM, ListBoxContainer.types.size.LARGE]),

  /** Lets the user control the X-axis offset for the ListBox content */
  contentOffsetX: _propTypes["default"].number,

  /** Lets the user control the Y-axis offset for the ListBox content */
  contentOffsetY: _propTypes["default"].number
};
exports.propTypes = propTypes;
var defaultProps = {
  children: null,
  hasError: false,
  hasTag: false,
  hasImplicitAll: false,
  height: 200,
  isDisabled: false,
  isInline: false,
  isMulti: false,
  isOpen: false,
  isReadOnly: false,
  onChange: function onChange() {},
  placeholder: null,
  size: ListBoxContainer.types.size.MEDIUM,
  contentOffsetX: 0,
  contentOffsetY: 0
};
exports.defaultProps = defaultProps;
ListBox.propTypes = propTypes;
ListBox.defaultProps = defaultProps;
ListBoxContainer.propTypes = propTypes;
ListBoxContainer.defaultProps = defaultProps;
var _default = ListBoxContainer;
exports["default"] = _default;
//# sourceMappingURL=ListBox.js.map